import get_title from "@/router/module/get_title";
import validate_role from "@/router/module/validate_role";
import createReference from "./detail/create";
import editReference from "./detail/edit";

export default {
  path: "/content/settings/reference",
  name: "Settings-Reference",
  component: () => import("@/new/pages/settings/reference/index.vue"),
  meta: {
    title: get_title("Настройки справочников"),
    forVisitors: true,
    requiresAuth: true
  },
  beforeEnter: (to, from, next) => {
    const options = {
      role: "settings_reference",
      route: { to, from, next },
      callback: false,
      redirectText: "У вас нет доступа к разделу с настройками!",
    };
    validate_role(options);
  },
  children: [createReference, editReference],
};
